<template>
  <TiptapFloatingMenu
    :editor="editor"
    v-if="editor"
    :options="{
      strategy: 'absolute',
      placement: 'right',
      offset: 20
    }"
  >
    <div class="floating-menu">
      <TipTapToolbarButton
        icon="mdi-format-paragraph"
        title="Paragraph"
        :isActive="editor?.isActive('paragraph')"
        @click="editor.chain().focus().setParagraph().run()"
        size="x-small"
      />

      <TipTapToolbarButton
        icon="mdi-format-header-1"
        title="Heading 1"
        :isActive="editor?.isActive('heading', { level: 1 })"
        @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
        size="x-small"
      />
      <TipTapToolbarButton
        icon="mdi-format-header-2"
        title="Heading 2"
        :isActive="editor?.isActive('heading', { level: 2 })"
        @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
        size="x-small"
      />
    </div>
  </TiptapFloatingMenu>
</template>

<script>
import { FloatingMenu as TiptapFloatingMenu } from '@tiptap/vue-3/menus';
import TipTapToolbarButton from './TipTapToolbarButton';

export default {
  name: 'FloatingMenu',

  components: {
    TiptapFloatingMenu,
    TipTapToolbarButton
  },

  props: {
    editor: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.floating-menu {
  display: flex;
  background-color: var(--gray-3);
  padding: 0.1rem;
  border-radius: 0.5rem;
  border: 1px solid rgb(229, 231, 235);
}
</style>
